import { Fragment, useState } from 'react';
import { Content, ExpandableContainer } from 'components';
import { Button, DatePicker, Input, Radio, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import styles from '../style/styles';
import dayjs from 'dayjs';

const INITIAL_VALUE = {
  productType: 'product_name',
  salesType: 'all',
  applicationType: 'all',
  type: 'all',
  keyword: '',
  dates: ['', ''],
  updates: ['', ''],
  exhibition: 'all',
};

const ProductSearch = ({ onSearch }) => {
  const [productType, setProductType] = useState('product_name');
  const [salesType, setSalesType] = useState('all');
  const [type, setType] = useState('all');
  const [keyword, setKeyword] = useState('');
  const [dateType, setDateType] = useState('register_date');
  const [dates, setDates] = useState(['', '']);
  const [updates, setUpdates] = useState(['', '']);

  const [searchValue, setSearchValue] = useState(INITIAL_VALUE);

  const handleChange = (t, v) => {
    setSearchValue((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  const handleChangeDate = (type, key) => {
    let startDate;
    let endDate = dayjs().format('YYYYMMDD'); // 오늘 날짜

    switch (type) {
      case 'today':
        startDate = endDate;
        break;
      case 'week':
        startDate = dayjs().subtract(7, 'day').format('YYYYMMDD');
        break;
      case 'month':
        startDate = dayjs().subtract(1, 'month').format('YYYYMMDD');
        break;
      case '3month':
        startDate = dayjs().subtract(3, 'month').format('YYYYMMDD');
        break;
      default:
        startDate = endDate;
    }

    handleChange(key, [startDate, endDate]);
  };
  const formItem = [
    {
      label: '검색어',
      direction: 'column',
      form: [
        {
          input: (
            <>
              <Select
                value={searchValue.productType}
                options={[
                  { label: '상품코드', value: 'product_code' },
                  { label: '상품명', value: 'product_name' },
                  { label: '상품구분', value: 'product_category' },
                  // { label: '제조사', value: '제조사' },
                  // { label: '카다로그명', value: '카다로그명' },
                  // { label: '브랜드명', value: '브랜드명' },
                ]}
                onChange={(value) => handleChange('productType', value)}
                style={{ ...styles.form.input.large }}
              />
              <Input
                placeholder="검색어를 입력해주세요"
                value={searchValue.keyword}
                onChange={(e) => handleChange('keyword', e.target.value)}
                style={{ ...styles.form.input.large, width: 350 }}
              />
              {/* <Button  icon={<PlusOutlined />} /> */}
            </>
          ),
        },
      ],
    },
    {
      label: '판매 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={searchValue.salesType}
                onChange={(e) => handleChange('salesType', e.target.value)}
              >
                <Radio value={'all'}>전체</Radio>
                <Radio value={'sales_wait'}>판매대기</Radio>
                <Radio value={'sales'}>판매중</Radio>
                <Radio value={'sold_out'}>품절</Radio>
                <Radio value={'sales_stop'}>판매중지</Radio>
                <Radio value={'sales_end'}>판매종료</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '심사 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={searchValue.applicationType}
                onChange={(e) =>
                  handleChange('applicationType', e.target.value)
                }
              >
                <Radio value={'all'}>전체</Radio>
                <Radio value={'apply'}>신청</Radio>
                <Radio value={'reject'}>반려</Radio>
                <Radio value={'approve'}>승인</Radio>
                <Radio value={'wait'}>대기</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    {
      label: '상품 구분',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={searchValue.type}
                onChange={(e) => handleChange('type', e.target.value)}
              >
                <Radio value={'all'}>전체</Radio>
                <Radio value={'delivery'}>일반배송</Radio>
                <Radio value={'rental'}>렌탈</Radio>
                <Radio value={'subscription'}>정기배송</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
    // {
    //   label: '상품 분류',
    //   form: [
    //     {
    //       input: (
    //         <>
    //           <Select
    //
    //             options={[
    //               { label: '대분류1', value: '대분류1' },
    //               { label: '대분류2', value: '대분류2' },
    //               { label: '대분류3', value: '대분류3' },
    //             ]}
    //             style={{ ...styles.form.input.large }}
    //             placeholder={'대분류 선택'}
    //           />
    //           <Select
    //
    //             options={[
    //               { label: '중분류1', value: '중분류1' },
    //               { label: '중분류2', value: '중분류2' },
    //               { label: '중분류3', value: '중분류3' },
    //             ]}
    //             style={{ ...styles.form.input.large }}
    //             placeholder={'중분류 선택'}
    //           />
    //           <Select
    //
    //             options={[
    //               { label: '소분류1', value: '소분류1' },
    //               { label: '소분류2', value: '소분류2' },
    //               { label: '소분류3', value: '소분류3' },
    //             ]}
    //             style={{ ...styles.form.input.large }}
    //             placeholder={'소분류 선택'}
    //           />
    //           <Select
    //
    //             options={[
    //               { label: '상세분류1', value: '상세분류1' },
    //               { label: '상세분류2', value: '상세분류2' },
    //               { label: '상세분류3', value: '상세분류3' },
    //             ]}
    //             style={{ ...styles.form.input.large }}
    //             placeholder={'상세분류 선택'}
    //           />
    //         </>
    //       ),
    //     },
    //   ],
    // },
    {
      label: '상품 등록일',
      form: [
        // {
        //   input: (
        //     <Select
        //
        //       value={dateType}
        //       options={[
        //         { label: '등록일', value: 'register_date' },
        //         { label: '최종 수정일', value: 'update_date' },
        //       ]}
        //       onChange={(value) => setDateType(value)}
        //       style={{ ...styles.form.input.large }}
        //     />
        //   ),
        // },
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('today', 'dates')}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('week', 'dates')}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('month', 'dates')}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('3month', 'dates')}
            >
              3개월
            </Button>
          ),
        },
        // {
        //   input: (
        //     <Button  style={{ ...styles.form.button }}>
        //       전체
        //     </Button>
        //   ),
        // },
        {
          input: (
            <>
              <DatePicker
                format={'YYYY.MM.DD'}
                placeholder=""
                value={searchValue.dates[0] ? dayjs(searchValue.dates[0]) : ''}
                onChange={(date) => {
                  handleChange('dates', [
                    date ? dayjs(date).format('YYYY.MM.DD') : '',
                    searchValue.dates[1],
                  ]);
                }}
                style={{ ...styles.form.date }}
                maxDate={dayjs(searchValue.dates[1])}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                format={'YYYY.MM.DD'}
                placeholder=""
                value={searchValue.dates[1] ? dayjs(searchValue.dates[1]) : ''}
                onChange={(date) =>
                  handleChange('dates', [
                    searchValue.dates[0],
                    date ? dayjs(date).format('YYYY.MM.DD') : '',
                  ])
                }
                style={{ ...styles.form.date }}
                minDate={dayjs(searchValue.dates[0])}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '최종 수정일',
      form: [
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('today', 'updates')}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('week', 'updates')}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('month', 'updates')}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              style={{ ...styles.form.button }}
              onClick={() => handleChangeDate('3month', 'updates')}
            >
              3개월
            </Button>
          ),
        },
        // {
        //   input: (
        //     <Button  style={{ ...styles.form.button }}>
        //       전체
        //     </Button>
        //   ),
        // },
        {
          input: (
            <>
              <DatePicker
                format={'YYYY.MM.DD'}
                placeholder=""
                value={
                  searchValue.updates[0] ? dayjs(searchValue.updates[0]) : ''
                }
                onChange={(date) => {
                  handleChange('updates', [
                    date ? dayjs(date).format('YYYY.MM.DD') : '',
                    searchValue.updates[1],
                  ]);
                }}
                style={{ ...styles.form.date }}
                maxDate={dayjs(searchValue.updates[1])}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                format={'YYYY-MM-DD'}
                placeholder=""
                value={
                  searchValue.updates[1] ? dayjs(searchValue.updates[1]) : ''
                }
                onChange={(date) =>
                  handleChange('updates', [
                    searchValue.updates[0],
                    date ? dayjs(date).format('YYYY.MM.DD') : '',
                  ])
                }
                style={{ ...styles.form.date }}
                minDate={dayjs(searchValue.updates[0])}
              />
            </>
          ),
        },
      ],
    },
    // {
    //   label: '진열 상태',
    //   form: [
    //     {
    //       input: (
    //         <>
    //           <Radio.Group value={'전체'}>
    //             <Radio value={'전체'}>전체</Radio>
    //             <Radio value={'진열함'}>진열함</Radio>
    //             <Radio value={'진열안함'}>진열안함</Radio>
    //           </Radio.Group>
    //         </>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   label: '판매 상태',
    //   form: [
    //     {
    //       input: (
    //         <>
    //           <Radio.Group value={'전체'}>
    //             <Radio value={'전체'}>전체</Radio>
    //             <Radio value={'판매함'}>판매함</Radio>
    //             <Radio value={'판매안함'}>판매안함</Radio>
    //           </Radio.Group>
    //         </>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   label: '마켓 연동',
    //   form: [
    //     {
    //       input: (
    //         <>
    //           <Radio.Group value={'전체'}>
    //             <Radio value={'전체'}>전체</Radio>
    //             <Radio value={'네이버'}>네이버</Radio>
    //             <Radio value={'카페24'}>카페24</Radio>
    //           </Radio.Group>
    //         </>
    //       ),
    //     },
    //   ],
    // },
    {
      label: '진열 상태',
      form: [
        {
          input: (
            <>
              <Radio.Group
                value={searchValue.exhibition}
                onChange={(e) => handleChange('exhibition', e.target.value)}
              >
                <Radio value={'all'}>전체</Radio>
                <Radio value={'best'}>베스트</Radio>
                <Radio value={'new'}>신상품</Radio>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  const handleSearch = (t = 'search') => {
    let search;

    if (t === 'search') {
      search = searchValue;
    } else {
      search = null;
      setSearchValue(INITIAL_VALUE);
    }

    if (onSearch) {
      onSearch(search);
    }
  };

  return (
    <Content
      maxWidth={'100%'}
      padding={0}
      backgroundColor={'none'}
      style={{ marginBottom: 40 }}
    >
      <ExpandableContainer borderRadius={4} padding={20} maxRows={8}>
        {formItem.map((_item, _index) => (
          <div
            key={`form_${_index}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px 0px',
            }}
          >
            <div
              style={{
                // width: 120, fontSize: 13, fontWeight: 400
                margin: '0 30px 0 10px',
                fontSize: 14,
                width: 85,
                fontWeight: '500',
                color: '#515151',
              }}
            >
              <label>{_item.label}</label>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {_item.form.map((_subitem, _subkey) => (
                <Fragment key={`input_${_subkey}`}>{_subitem.input}</Fragment>
              ))}
            </div>
          </div>
        ))}
      </ExpandableContainer>

      {/* 검색/초기화 버튼 */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          margin: '15px 0 45px',
        }}
      >
        <Button
          type="primary"
          style={{ ...styles.button, background: 'var(--primary-color)' }}
          onClick={() => handleSearch('search')}
        >
          검색
        </Button>
        <Button
          style={{ ...styles.button }}
          onClick={() => handleSearch('reset')}
        >
          초기화
        </Button>
      </div>
      {/* 검색/초기화 버튼 끝 */}
    </Content>
  );
};

export default ProductSearch;
